<template>
  <tr class="table-row"
    :class="{ 'table-row--parent': row[childDataKey] }">
    <slot></slot>
  </tr>
</template>

<script>
export default {
  props: {
    row: Object,
    rowId: {
      type: String|Number
    },
    rowData: {
      type: Array
    },
    childDataKey: {
      type: String,
      default: 'childData'
    }
  },
  data() {
    return {};
  },
  provide() {
    return {
      item: this
    };
  },
};
</script>
